export const getCountryDevicesQuantity = (resolve, reject, tokenId) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getdevicesquantity', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    }
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getCountryDevicesQuantity response format error.');
      }
    } else {
      reject('getCountryDevicesQuantity response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getStateDevicesQuantity = (resolve, reject, tokenId, countryName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getdevicesquantity', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      country: countryName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getStateDevicesQuantity response format error.');
      }
    } else {
      reject('getStateDevicesQuantity response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getCityDevicesQuantity = (resolve, reject, tokenId, stateName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getdevicesquantity', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      state: stateName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getCityDevicesQuantity response format error.');
      }
    } else {
      reject('getCityDevicesQuantity response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getQueryDevicesByCity = (resolve, reject, tokenId, cityName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/querydevices', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      city: cityName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getQueryDevicesByCity response format error.');
      }
    } else {
      reject('getQueryDevicesByCity response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}